declare namespace $ {

	type $mol_string__hint_shm_hitalama_map_page_contextmenu_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_hitalama_map_page_contextmenu_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_contextmenu['query'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_hitalama_map_page_contextmenu_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_contextmenu['submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_hitalama_map_page_contextmenu_4 = $mol_type_enforce<
		({ 
			keydown( next?: ReturnType< $shm_hitalama_map_page_contextmenu['search_keydown'] > ): ReturnType< $shm_hitalama_map_page_contextmenu['search_keydown'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_list__rows_shm_hitalama_map_page_contextmenu_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_contextmenu['rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $shm_hitalama_map_widget_presets__map_shm_hitalama_map_page_contextmenu_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_contextmenu['map'] >
		,
		ReturnType< $shm_hitalama_map_widget_presets['map'] >
	>
	type $shm_hitalama_map_page_contextmenu_add__Icon_shm_hitalama_map_page_contextmenu_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_contextmenu['item_icon'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu_add['Icon'] >
	>
	type $shm_hitalama_map_page_contextmenu_add__title_shm_hitalama_map_page_contextmenu_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_contextmenu['item_title'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu_add['title'] >
	>
	type $shm_hitalama_map_page_contextmenu_add__click_shm_hitalama_map_page_contextmenu_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_contextmenu['widget_add'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu_add['click'] >
	>
	type $shm_hitalama_map_page_contextmenu_add__attr_custom_shm_hitalama_map_page_contextmenu_10 = $mol_type_enforce<
		({ 
			'widget_type': ReturnType< $shm_hitalama_map_page_contextmenu['id'] >,
			'selected': ReturnType< $shm_hitalama_map_page_contextmenu['item_selected'] >,
		}) 
		,
		ReturnType< $shm_hitalama_map_page_contextmenu_add['attr_custom'] >
	>
	type $mol_view__sub_shm_hitalama_map_page_contextmenu_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_contextmenu['items_top'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_page_contextmenu_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_contextmenu['items_top2'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_map_page_contextmenu_add__Icon_shm_hitalama_map_page_contextmenu_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_contextmenu['custom_add_icon'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu_add['Icon'] >
	>
	type $shm_hitalama_map_page_contextmenu_add__title_shm_hitalama_map_page_contextmenu_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_contextmenu['custom_add_title'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu_add['title'] >
	>
	type $shm_hitalama_map_page_contextmenu_add__click_shm_hitalama_map_page_contextmenu_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_page_contextmenu['custom_add'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu_add['click'] >
	>
	type $shm_hitalama_map_page_contextmenu_add__attr_custom_shm_hitalama_map_page_contextmenu_16 = $mol_type_enforce<
		({ 
			'selected': ReturnType< $shm_hitalama_map_page_contextmenu['custom_selected'] >,
		}) 
		,
		ReturnType< $shm_hitalama_map_page_contextmenu_add['attr_custom'] >
	>
	export class $shm_hitalama_map_page_contextmenu extends $mol_list {
		contextmenu_real_pos( ): readonly(any)[]
		search_focus( ): any
		item_icon( id: any): $mol_icon_square_outline
		item_title( id: any): string
		widget_add( id: any, next?: any ): any
		id( id: any): string
		item_selected( id: any): boolean
		query( next?: string ): string
		submit( next?: any ): any
		search_keydown( next?: any ): any
		Search( ): $mol_string
		rows( ): readonly($mol_view)[]
		List( ): $mol_list
		items_top( ): readonly(any)[]
		items_top2( ): readonly(any)[]
		custom_add_icon( id: any): $mol_icon_plus
		custom_add_title( id: any): string
		custom_add( id: any, next?: any ): any
		custom_selected( id: any): boolean
		map( ): $shm_hitalama_map
		Map_page( ): $shm_hitalama_map_page
		add_pos( ): ReturnType< $shm_hitalama_map_page_contextmenu['contextmenu_real_pos'] >
		contextmenu_showed( next?: boolean ): boolean
		selected_id( next?: string ): string
		auto( ): readonly(any)[]
		presets( ): $shm_hitalama_map_widget_presets
		item_ids_top( ): readonly(any)[]
		item_ids_top2( ): readonly(any)[]
		item_ids( ): readonly(any)[]
		Item_add( id: any): $shm_hitalama_map_page_contextmenu_add
		sub( ): readonly(any)[]
		Top( ): $mol_view
		Top2( ): $mol_view
		Custom_add( id: any): $shm_hitalama_map_page_contextmenu_add
	}
	
	export class $shm_hitalama_map_page_contextmenu_add extends $mol_button_minor {
		attr_custom( ): Record<string, any>
		Icon( ): $mol_icon_square_outline
		sub( ): readonly(any)[]
		attr( ): Record<string, any> & ReturnType< $mol_button_minor['attr'] > & ReturnType< $shm_hitalama_map_page_contextmenu_add['attr_custom'] >
	}
	
}

//# sourceMappingURL=contextmenu.view.tree.d.ts.map